import esCL from 'vee-validate/dist/locale/es.json'

export default {
    validation: esCL.messages,
    Titles: {
        recentAssessments: 'Evaluaciones recientemente completadas',
        filters: 'Filtrar',
        ambientMode: 'Demostración',
    },
    Alerts: {
        deletePicture: 'Esta foto no podrá recuperarse',
        noAddress: 'Perfil sin dirección',
        yourEmail: 'Su correo electrónico',
        unsavedChanges:
            'Usted tiene cambios no guardados. ¿Te gustaría salvarlos antes de irte?',
        removeProfile: 'Estás eliminando un perfil de {location}',
        inactiveAttendance:
            'Los estudiantes inactivos no pueden hacer Asistencia',
        askChangeDate: '¿Seguro que quieres cambiar la fecha?',
        deactivateClass: 'Esta clase ya no aparecerá en el mapa de ocupación',
        askNewAttendance: '¿Hacer otra Asistencia?',
        attendanceLost: '¡Las Asistencias no guardadas se perderán!',
        noImage: 'El archivo debe ser una imagen.',
        copyToClipboard: 'Copiado al portapapeles',
        saveSuccess: 'Guardado con éxito',
        changedSuccess: 'Alterado con éxito',
        createdSuccess: 'Creado con éxito',
        deletedSuccess: 'Deletado con éxito',
        removedSuccess: 'Removido con éxito',
        sendSuccess: 'Enviado con éxito',
        sure: 'Estás seguro ?',
        irreversible: '¡Esta acción es irreversible!',
        cancel: 'Cancelar',
        no: 'No',
        yes: 'Si',
        deleteAction: 'Confirmar',
        userError: 'Algo salió mal, inténtalo de nuevo más tarde.',
        usersLimit:
            'Ha alcanzado el límite de registro en su plan, comuníquese con su Customer Success',
        noProfileSelected: 'Se debe seleccionar un perfil',
        cantDeleteYourself: 'No puedes deshabilitar/deletar tu propio perfil',
        cantInactivateLoggedLocation:
            'No se puede desactivar la misma unidad en la que inició sesión',
        askDeactivate: '¿Realmente quieres inactivar este registro?',
        warningDeactivate: 'Él/ella ya no podrá acceder a la plataforma',
        askDeactivateLocation: '¿Realmente quieres desactivar esta unidad?',
        warningDeactivateLocation:
            'Todas las personas registradas en esta unidad perderán acceso!',
        sessionExpired: 'Su sección ha caducado, inicie sesión nuevamente',
        cantChangeProfile:
            'No es posible alterar un perfil en un usuario deshabilitado.',
        deleteAlert:
            'Para eliminar los registros, haga clic en el botón Eliminar.',
        selectUsersToDelete: 'Seleccione los registros que desea eliminar.',
        saveFirst: 'Para continuar, debe guardar.',
        selectAll: 'Seleccione todos los elementos antes de agregar',
        registerLesson: 'Registre al menos una clase antes de guardar.',
        accessDenied: 'No tiene permiso para esta funcionalidad.',
        notFound: 'Página não encontrada',
        serverError:
            'Ocorreu um erro no servidor, por favor tente novamente mais tarde',
        studentAlreadyIncluded:
            '¡Este estudiante ya está registrada con este apoderado!',
        maxLevelStudents:
            'Recomendamos {maxStudents} estudiantes para este nivel',
        selectLevelFirst: 'Seleccione un nivel antes de elegir estudiantes',
        diferentLevel:
            'Este estudiante está en un nivel diferente de la clase.',
        studentAlreadyIncludedInClass:
            'Este estudiante ya está incluido en esta clase.',
        changingLevelClass:
            '¿Estás seguro de que quieres cambiar el nivel de esta sala?',
        removeStudents: 'Todos los estudiantes viejos serán removidos',
        checkAllStudents:
            'Todos los estudiantes deben estar marcados con presencia / ausencia antes de guardar!',
        onlyActiveUsers: 'Solo se pueden agregar usuarios activos',
        noQuestions:
            'No es posible hacer un modelo de evaluación sin preguntas',
        activeAssessment:
            'Una vez que esta revisión sea efectiva, ya no podrá editarla',
        selectItemsFirst: 'Seleccione los elementos que se eliminarán.',
        selectStudents: 'Seleccione estudiantes para tomar la evaluación.',
        selectStudentsToAttendance:
            'Seleccione estudiantes para tomar la Asistencia',
        studentWithoutAnswer:
            'Antes de continuar, ingrese el resultado de todos los estudiantes',
        pauseAlert: 'Pausará la evaluación de este estudiante',
        pauseDescription: 'Pero puedes continuar evaluándolo más tarde',
        studentsWithoutComments:
            'Los estudiantes marcados "Sí" deben tener un comentario',
        studentsNoCheck:
            'Antes de continuar, marque a los estudiantes que tienen comentarios o no',
        deleteFolder:
            'Eliminará esta carpeta y todo su contenido. Esta acción es irreversible.',
        selectFile: 'Seleccione el archivo para guardar',
        invalidDateValue: 'Rango de tiempo inválido',
        maxSize: 'Solo puede guardar archivos hasta 10MB',
        cantDownload: 'No tienes permiso para descargar este archivo',
        changePasswordSuccess: 'Contraseña alterada con éxito',
        cantEditAssessment: 'La evaluación finalizada no se puede editar',
        goToNewAssessments:
            'Utilice las evaluaciones a través del nuevo panel, simplemente acceda a "Panel nuevo" en el menú y haga clic en "Acceder al panel".',
        wantDoAssessment: '¿Quieres hacer una Evaluación?',
    },
    Menu: {
        profile: 'Mi perfil',
        attendance: 'Llamada',
        occupancyMap: 'Mapa de ocupación',
        partners: 'Parceros',
        newPartner: 'Nuevo parcero',
        editPartner: 'Editar parcero',
        integration: 'Integración',
        newIntegration: 'Nueva integración',
        partnerManagement: 'Gestión de integracciones',
        newPartnerToken: 'Nuevo token de parcero',
        students: 'Estudiantes',
        newStudent: 'Nuevo estudiante',
        editStudent: 'Editar estudiante',
        responsible: 'Apoderados',
        classLesson: 'Clase',
        newResponsible: 'Nuevo apoderado',
        editResponsible: 'Editar apoderado',
        classgrade: 'Salas',
        newClassgrade: 'Crear nueva sala',
        editClassGrade: 'Editar sala',
        teachingAreas: 'Piscinas',
        newTeachingAreas: 'Crear nueva piscina',
        editTeachingAreas: 'Editar piscina',
        team: 'Personal',
        newTeam: 'Crear nuevo equipo',
        editTeam: 'Editar un miembro del equipo',
        assessmentStudents: 'Evaluaciones',
        assessmentStudentsNewModule: 'Panel nuevo',
        assessmentResult: 'Resultado de la evaluacion',
        assessmentApplication: 'Aplicando evaluacion',
        showStores: 'Mis Tiendas',
        SubItems: {
            pedagogic: 'Pedagógica',
            configurations: 'Ajustes',
        },
        goals: 'Objetivos',
        newGoal: 'Nuevo objectivo',
        editGoal: 'Editar objetcivo',
        contents: 'Contenidos',
        newContent: 'Nuevo contenido',
        editContent: 'Editar contenido',
        scheduleMap: 'Calendário de objectivos',
        newScheduleMap: 'Nuevo calendário de objectivos',
        newLesson: 'Nueva aula',
        editLesson: 'Editar aula',
        editScheduleMap: 'Editar calendário de objectivos',
        assessmentModel: 'Modelos de evaluacionas',
        newAssessmentModel: 'Nuevo modelo de evaluacion',
        editAssessmentModel: 'Editar modelo de evaluacion',
        newAssessmentQuestion: 'Nueva pregunta',
        editAssessmentQuestion: 'Editar pregunta',
        plans: 'Planes',
        newPlans: 'Crear nuevo plane',
        editPlan: 'Editar o plane',
        clients: 'Acreditados',
        newClient: 'Nuevo acreditado',
        editClient: 'Actualizar acreditado',
        locations: 'Unidades',
        newLocation: 'Nueva unidad',
        editLocation: 'Editar la unidad',
        locationBuyers: 'Lojistas',
        newLocationBuyer: 'Nuevo lojista',
        editLocationBuyer: 'Editar lojista',
        staff: 'Staff ',
        newStaff: 'Nuevo staff',
        editStaff: 'Editar staff',
        uploads: 'Administrador de archivos',
        downloads: 'Downloads',
        courses: 'Cursos',
        certification: 'Certificación',
        faq: 'Dudas',
    },
    Errors: {
        notImage: 'Sem imagem',
        invalidLogin: 'Correo electrónico o contraseña no válidos',
        minValue: 'Ingrese un valor mayor que 0',
        accessDenied:
            'El usuario no tiene un perfil con acceso a la herramienta.',
        selectLocation: 'Seleccione una unidad antes de continuar',
        emailNotFound: 'Email no registrado',
        invalidDate: 'Por favor, introduzca una fecha válida',
        requiredField: 'Este campo es obligatorio',
        emailFormat: 'Este campo debe tener el formato ***@***.***',
        invalidCep: 'Por favor ingrese un código postal válido',
        dateFromToday: 'No puede ser menos que hoy',
        error_400: {
            title: 'Error de solicitud',
            description: '',
        },
        error_401: {
            title: 'No autorizado',
            description: '',
        },
        error_403: {
            title: 'Acceso prohibido',
            description: '',
        },
        error_404: {
            title: 'Página no encontrada',
            description: 'No se pudo encontrar la página solicitada',
        },
        error_500: {
            title: 'Error del servidor',
            description: 'inténtalo de nuevo más tarde.',
        },
        invalidHours: 'Ingrese un rango de horas válido',
        invalidHour: 'Ingrese una hora valida',
        typePositiveNumber: 'El número de estudiantes debe ser mayor que 0',
        inactiveUser: 'Seleccione una opción activa para continuar.',
        invalidCPF: 'El RUT está incompleto; debe tener 11 números',
        invalidCNPJ: 'El CNPJ está incompleto; debe tener 14 números',
        specialCharacter: 'No se permite el uso de caracteres especiales.',
        passwordLengthRule:
            'La contraseña debe tener al menos 8 y un máximo de 100 caracteres.',
    },
    Language: {
        portuguese: 'Portugués',
        spanish: 'Espanol',
        english: 'Ingles',
    },
    Login: {
        welcome: 'Sea bienvenido',
        presentationText:
            'Administre sus unidades y clientes de una manera fácil, visual e intuitiva.',
        quote: 'Educación a través de la natación.',
        forgotPassword: 'Olvidaste tu contraseña?',
        insertEmail:
            'Ingrese su correo electrónico para restablecer su contraseña:',
        chooseLocation: 'Elige una unidad',
        locationText:
            'Antes de iniciar sesión, elija la unidad de la lista a continuación.',
        insertPassword: 'Nueva contraseña',
        successNewPassword: 'Contraseña alterada con éxito.',
        resetPasswordInform:
            'Enviamos un correo electrónico a {userEmail} con instrucciones y un enlace para cambiar su contraseña. Si no recibe el correo electrónico en unos minutos, verifique su dirección de correo electrónico en el sitio web o repita el proceso.',
    },
    Fields: {
        names: {
            email: 'E-mail',
            password: 'Contraseña',
        },
        labels: {
            replace: 'Reemplazo',
            email: 'E-mail',
            password: 'Contraseña',
            users: 'Usuarios',
            students: 'Estudiantes',
            points: 'Puntos',
            inactive: 'INACTIVO',
            yes: 'Si',
            no: 'No',
            achievement: 'logro',
            uploadFile:
                'Arrastre un archivo aquí o haga clic para seleccionar un archivo',
            characters: 'caracteres',
            items: 'Itens',
            currentPassword: 'Contraseña actual',
            newPassword: 'Nueva contraseña',
            confirmPassword: 'Confirmar nueva contraseña',
        },
        select: {
            searchStudent: 'Buscar por nombre del estudiante',
            selectLabel: 'Seleccione',
            deselectLabel: 'Eliminar',
            noResult: 'No hay resultados de búsqueda',
            noOptions: 'La lista está vacía',
            selectOption: 'Seleccione una opcíon',
            searchOption: 'Ingrese tu busca',
            locationPlaceholder: 'Selecciona una unidad',
            selected: 'Seleccionado',
            other: 'Otro',
            male: 'Masculino',
            female: 'Femenino',
            searchHere: 'Tu búsqueda aparecerá aquí',
            selectAll: 'Seleccionar todos',
            options: {
                Permission: [
                    {
                        name: 'Público',
                        value: 0,
                    },
                    {
                        name: 'Privado',
                        value: 1,
                    },
                ],
                Situation: [
                    {
                        name: 'Activo',
                        value: true,
                    },
                    {
                        name: 'Inactivo',
                        value: false,
                    },
                ],
                UnitTypes: [
                    {
                        name: 'Gimnasio',
                        value: 1,
                    },
                    {
                        name: 'Escuela',
                        value: 2,
                    },
                    {
                        name: 'Club',
                        value: 3,
                    },
                ],
                Entity: [
                    {
                        name: 'Individual / Individual',
                        value: 1,
                    },
                    {
                        name: 'Corporativo / PJ',
                        value: 2,
                    },
                    {
                        name: 'Internacional',
                        value: 3,
                    },
                ],
                QuestionItemType: [
                    {
                        name: 'Realiza',
                        value: 0,
                    },
                    {
                        name: 'Valor',
                        value: 1,
                    },
                    {
                        name: 'Tiempo',
                        value: 2,
                    },
                ],
            },
        },
        placeholder: {
            newPassword: 'Nueva contraseña',
            typeQuery: 'Escribe tu búsqueda',
        },
        values: {
            copyOf: 'Copia del',
        },
        filters: {
            filterText: 'Filtros',
        },
    },
    Buttons: {
        choosePhoto: 'Escolher foto',
        cutAndSave: 'Cortar y guardar',
        reset: 'Reiniciar',
        changePhoto: 'Cambiar foto',
        removePhoto: 'Eliminar foto',
        myProfile: 'Mi perfil',
        changeDate: 'Cambiar la fecha',
        doAttendance: 'Hacer asistencia',
        send: 'Enviar',
        resendEmail: 'Resetar contraseña',
        copyToken: 'Copiar token',
        back: 'Volver',
        logIn: 'Iniciar sesión',
        continue: 'Continuar',
        save: 'Guardar',
        exit: 'Salir',
        changeLocation: 'Cambiar unidad',
        pagination: 'Vea más',
        new: 'Nuevo',
        doAssessment: 'Hacer evaluación',
        continueAssessment: 'Continuar evaluación',
        addLessons: 'Agregar classes',
        update: 'Actualizar',
        newResponsible: 'Registrar nuevo apoderado',
        newStudent: 'Registrar estudiante',
        newLocation: 'Registrar nueva unidad',
        today: 'Hoy',
        saveAttendance: 'Guardar Asistencia',
        inactive: 'Inactivo',
        shopkeeper: 'Lojista',
        newQuestion: 'Registrarse pregunta',
        addArchive: 'Agregar archivo',
        filter: 'Filtrar',
        cleanFilter: 'Limpar filtros',
        changeImage: 'Cambiar/limpar foto',
        accessEcommerce: 'Acceder al comercio electrónico',
        changePassword: 'Cambiar contraseña',
        add: 'Agregar',
        edit: 'Editar',
        clone: 'Duplicar',
        delete: 'Eliminar',
        pause: 'Pausar',
    },
    Table: {
        noData: 'Sem dados',
        noEmail: 'No ingresado',
        noImage: 'Sem logo',
        titles: {
            studentsLimit: 'Limite de estudiantes',
            employeesLimit: 'Límite de empleados',
            private: 'Privado',
            partner: 'Parcero',
            location: 'Unidad',
            releaseDate: 'Data de lançamento',
            generationDate: 'Fecha de generación',
            name: 'Nombre',
            nameClassGrade: 'Nombre de la clase',
            buyer: 'Comprador',
            evaluator: 'Evaluador',
            asssessmentComments: 'Comentar',
            email: 'E-mail',
            profile: 'Perfil',
            phone: 'Teléfono',
            status: 'Activo/Inactivo',
            actions: 'Acciones',
            dimensions: 'Dimensiones',
            depth: 'Profundidad',
            squareMeter: 'Metro cuadrado',
            planName: 'Nombre del plan',
            description: 'Descripción',
            modules: 'Módulos',
            allowed: 'Permitido',
            startDate: 'Inicio',
            startTime: 'Hora',
            teacher: 'Profesor',
            dayOfWeek: 'Dia de la semana',
            vacances: 'Vacantes',
            endDate: 'Final',
            levels: 'Niveles',
            level: 'Nivel',
            active: 'Activo',
            objective: 'Objectivo',
            contents: 'Contenidos',
            textPTBR: 'Português',
            textES: 'Espanhol',
            textEN: 'Inglês',
            companyName: 'Nombre social',
            tradingName: 'Nome de fantasia',
            document: 'Documento',
            registration: 'Matricula',
            customerSuccess: 'Customer Success',
            cityState: 'Ciudad - Estado',
            plan: 'Plan',
            type: 'Especie',
            age: 'Edad',
            presence: 'Presencia',
            pedagogicType: 'Tipo pedagógico',
            quantityQuestion: 'Preguntas',
            assessmentAccomplishedScore: 'Nota',
            current: 'En Vigor',
            assessmentStatus: 'Status',
            questions: 'Preguntas',
            items: 'Itens',
            points: 'Nota',
            order: 'Ordenación',
            published: 'Publicado',
            execute: 'Realiza',
            hitRate: 'Tasa de aciertos',
            comments: 'Comentarios',
        },
        noEndDate: 'Sin data finale',
        noClassName: '[Clase sin nombre]',
        noClassTeacher: '[Clase sin profesor]',
        noComments: 'Estudiante sin comentario',
        ready: 'Listo',
        inProgress: 'Borrador',
        to: 'para',
        inactiveProfile: 'Este perfil está inativo',
        months: 'mes(es)',
        age: 'año(s)',
    },
    Profiles: [
        {
            text: 'Propietario',
            textShow: 'Owner',
            value: '1',
        },
        {
            text: 'Coordinador',
            textShow: 'Coordinator',
            value: '2',
        },
        {
            text: 'Maestro',
            textShow: 'Teacher',
            value: '3',
        },
        {
            text: 'Alumno',
            textShow: 'Student',
            value: '4',
        },
        {
            text: 'Customer Success',
            textShow: 'CustomerSuccess',
            value: '5',
        },
        {
            text: 'Gerente',
            textShow: 'Manager',
            value: '6',
        },
        {
            text: 'Administrador',
            textShow: 'Admin',
            value: '7',
        },
        {
            text: 'Secretária',
            textShow: 'Secretary',
            value: '8',
        },
        {
            text: 'Apoderado',
            textShow: 'Responsible',
            value: '9',
        },
        {
            text: 'Soporte',
            textShow: 'Support',
            value: '10',
        },
        {
            text: 'Pedagogo',
            textShow: 'Educator',
            value: '11',
        },
        {
            text: 'Vendas',
            textShow: 'Seller',
            value: '12',
        },
        {
            text: 'Marketing',
            textShow: 'Marketing',
            value: '13',
        },
        {
            text: 'Desenvolvedor',
            textShow: 'Developer',
            value: '14',
        },
    ],
    Status: [
        {
            name: 'Activo',
            value: true,
        },
        {
            name: 'Inactivo',
            value: false,
        },
    ],
    YesNoOptions: [
        {
            name: 'Si',
            value: true,
        },
        {
            name: 'No',
            value: false,
        },
    ],
    Inputs: {
        selectAttendanceDate: 'Seleccione a fecha de Asistencia',
        attendanceDate: 'Fecha de Asistencia',
        releaseDate: 'Fecha de lanzamiento',
        name: 'Nombre',
        nameClassGrade: 'Nombre de la clase',
        partnerSelect: 'Seleccione um parcero',
        dateTime: 'Seleccionar fecha y hora',
        firstName: 'Nombre',
        lastName: 'Apellido',
        gender: 'Género',
        birthday: 'Fecha de nacimiento',
        cpf: 'RUT',
        email: 'E-mail',
        studentEmail: 'E-mail del estudiante',
        telephone: 'Número de contacto',
        postalCode: 'Código postal',
        address: 'Dirección',
        addressNumber: 'Número',
        addressComplement: 'Complemento',
        neighborhood: 'Barrio',
        country: 'País',
        state: 'Estado',
        city: 'Ciudad',
        weekdaySelect: 'Selecciona un día de la semana',
        studentSelect: 'Selecione un estudiante',
        levelSelect: 'Seleccionar un nivel',
        teacherSelect: 'Seleccione un profesor',
        poolSelect: 'Seleccionar un grupo',
        unitSelect: 'Seleccionar una unidad',
        unitSelectSimple: 'Seleccionar una unidad',
        unitTypeSelect: 'Seleccione el tipo de unidad',
        entitySelect: 'Seleccione el tipo de entidad',
        planSelect: 'Seleccionar un plan',
        plansSelect: 'Seleccione los planos',
        profilesSelect: 'Selecione los perfiles',
        customerSuccessSelect: 'Seleccionar un customer success',
        situationSelect: 'Seleccionar el estado',
        pedagogicTypeSelect: 'Seleccione el tipo pedagógico',
        calendarSelect: 'Seleccionar la fecha',
        calendarTypeSelect: 'Seleccione el tipo de calendario',
        assessmentQuestionItemTypeSelect: 'Seleccione el tipo de pregunta',
        clientSelect: 'Seleccione el cliente',
        monthlyFee: 'Cuota mensual',
        registration: 'Numero de contrato',
        platformAccessToggle: '¿Puede acceder a este sistema?',
        poolName: 'Nombre de la piscina',
        poolDescription: 'Descripción de la piscina',
        poolLength: 'Longitud',
        poolWidth: 'Ancho',
        poolDepth: 'Profundidad',
        numberOfStudents: 'Número de estudiantes',
        numberOfStudentsInClass: 'Número de estudiantes registrados',
        classStartTime: 'Hora de inicio',
        classEndTime: 'Hora de finalización',
        weekdays: 'Dia de clase',
        tradingName: 'Nombre de fantasía',
        companyName: 'Nombre corporativo',
        document: 'Documento',
        stateRegistration: 'Registro de estado',
        municipalRegistration: 'Registro municipal',
        personalWebsite: 'Sitio web',
        facebook: 'Facebook',
        instagram: 'Instagram',
        calendarDescription: 'Descripción del calendario',
        planLimitStudentsToggle: '¿Ilimitados?',
        planLimitStudentsInput: 'Limite de estudiantes?',
        planLimitStaffToggle: '¿Ilimitados?',
        planLimitStaffInput: 'Limite de empleados',
        planDescription: 'Descripción del plan',
        planColor: 'Color del plan',
        portugueseLanguage: 'Portugués',
        englishLanguage: 'Ingles',
        spanishLanguage: 'Español',
        toggleCurrentAssessment: 'Actual',
        assessmentQuestion: 'Escriba la pregunta de esta evaluación',
        assessmentQuestionItem: 'Escriba el ítem de esta pregunta',
        assessmentQuestionItemGrade: 'Puntos de este ítem',
        accreditedName: 'Nombre acreditado',
        availableCharacters: 'Caracteres disponibles',
        initialDate: 'Fecha inicial',
        endDate: 'Fecha final',
        rangeDate: 'Seleccione un periodo',
        statusSelect: 'Seleccione un estado',
        hasResponsibleSelect: 'Estudiante con apoderado',
        hasStudentSelect: 'Apoderado con estudiante',
        hasEmailSelect: 'Con/Sin email',
        plataformAccessSelect: 'Acceso a la plataforma',
        goalsSelect: 'Seleccione un objectivo',
        contentsSelect: 'Seleccione los contenudos',
        staffSelect: 'Seleccione un contribuidor MGB',
        filterLevel: 'Nivel(es)',
        filterPool: 'Piscina(s)',
        filterTeacher: 'Profesor(es)',
        selectTeachers: 'Todos los profesores',
        selectPools: 'Todas las piscinas',
        selectLevels: 'Todos los niveles',
        buyerSelect: 'Comprador',
        current: 'Actual',
        points: 'Puntos:',
        questionItem: 'Ingrese lo íten desta pregunta',
        itemType: 'Tipo',
        itemPoints: 'Nota',
        order: 'Ordenación',
        assessmentComments: 'Comentarios de los estudiantes',
        fileName: 'Nombre del archivo',
        description: 'Descrición',
        permissionSelect: 'Publico/Privado',
        languageSelect: 'Selecciona un idioma',
    },
    States: {
        Brazil: [
            {
                abbv: 'AC',
                full: 'Acre',
            },
            {
                abbv: 'AL',
                full: 'Alagoas',
            },
            {
                abbv: 'AP',
                full: 'Amapá',
            },
            {
                abbv: 'AM',
                full: 'Amazonas',
            },
            {
                abbv: 'BA',
                full: 'Bahia',
            },
            {
                abbv: 'CE',
                full: 'Ceará',
            },
            {
                abbv: 'DF',
                full: 'Distrito Federal',
            },
            {
                abbv: 'ES',
                full: 'Espírito Santo',
            },
            {
                abbv: 'GO',
                full: 'Goiás',
            },
            {
                abbv: 'MA',
                full: 'Maranhão',
            },
            {
                abbv: 'MT',
                full: 'Mato Grosso',
            },
            {
                abbv: 'MS',
                full: 'Mato Grosso do Sul',
            },
            {
                abbv: 'MG',
                full: 'Minas Gerais',
            },
            {
                abbv: 'PA',
                full: 'Pará',
            },
            {
                abbv: 'PB',
                full: 'Paraíba',
            },
            {
                abbv: 'PR',
                full: 'Paraná',
            },
            {
                abbv: 'PE',
                full: 'Pernambuco',
            },
            {
                abbv: 'PI',
                full: 'Piauí',
            },
            {
                abbv: 'RJ',
                full: 'Rio de Janeiro',
            },
            {
                abbv: 'RN',
                full: 'Rio Grande do Norte',
            },
            {
                abbv: 'RS',
                full: 'Rio Grande do Sul',
            },
            {
                abbv: 'RO',
                full: 'Rondônia',
            },
            {
                abbv: 'RR',
                full: 'Roraima',
            },
            {
                abbv: 'SC',
                full: 'Santa Catarina',
            },
            {
                abbv: 'SP',
                full: 'São Paulo',
            },
            {
                abbv: 'SE',
                full: 'Sergipe',
            },
            {
                abbv: 'TO',
                full: 'Tocantins',
            },
        ],
    },
    DaysOfWeek: [
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
        'Domingo',
    ],
    Levels: [
        {
            abbreviaton: 'BB1',
            color: 'avtWhite',
            name: 'Bebê 1',
            id: 1,
        },
        {
            abbreviaton: 'BB2',
            color: 'avtWhite',
            name: 'Bebê 2',
            id: 2,
        },
        {
            abbreviaton: 'BB3',
            id: 3,
            color: 'avtYellow',
            name: 'Bebê 3',
        },
        {
            abbreviaton: 'ADAP',
            id: 4,
            color: 'avtOrange',
            name: 'Adaptação Infantil',
        },
        {
            abbreviaton: 'INIC',
            id: 5,
            color: 'avtRed',
            name: 'Iniciação Infantil',
        },
        {
            abbreviaton: 'AP1',
            id: 6,
            color: 'avtGreen',
            name: 'Aperfeiçoamento 1',
        },
        {
            abbreviaton: 'AP2',
            id: 7,
            color: 'avtLightBlue',
            name: 'Aperfeiçoamento 2',
        },
        {
            abbreviaton: 'AP3',
            id: 8,
            color: 'avtHeavyBlue',
            name: 'Aperfeiçoamento 3',
        },
        {
            abbreviaton: 'EQ',
            id: 9,
            color: 'avtYellow',
            name: 'Equipe',
        },
        {
            abbreviaton: 'FS',
            id: 10,
            color: 'avtBlack',
            name: 'Fast swim',
        },
        {
            abbreviaton: 'COND1',
            id: 11,
            color: 'avtBlack',
            name: 'Condicionamento 1',
        },
        {
            abbreviaton: 'COND2',
            id: 12,
            color: 'avtBlack',
            name: 'Condicionamento 2',
        },
        {
            abbreviaton: 'ADAP_AD',
            id: 13,
            color: 'avtBlack',
            name: 'Adaptação Adulto',
        },
        {
            abbreviaton: 'INIC_AD',
            id: 14,
            color: 'avtBlack',
            name: 'Iniciação Adulto',
        },
    ],
    Subtitles: {
        periods: 'Vista de Lecciones agrupadas por períodos',
        classes: 'Clase',
        profiles: 'Perfis',
        units: 'Unidades',
        responsibles: 'Apoderados',
        students: 'Estudiantes',
        registrationData: 'Datos de registro',
        contractualData: 'Datos contractuales',
        socialNetwork: 'Sitio web y redes sociales',
        locationData: 'Dados da la unidad',
        locationStore: 'Lista de lojas',
        aboutLesson: 'Sobre la clase',
        aboutStudents: 'Sobre los estudiantes',
        questions: 'Preguntas',
        questionItems: 'artículos de pregunta',
        aboutAssessment: 'Sobre la evaluación',
        assessmentPerformance: 'Evaluación general de desempeño',
        assessmentComentary: 'Comentarios de evaluación',
        assessmentDetails: 'Detalles da evaluación',
    },
    Descriptions: {
        performanceDescription:
            'resumen del rendimiento del estudiante en esta evaluación, a continuación se enumeran las preguntas que se aplicaron',
        assessmentDetailsDescription:
            'detalles de las preguntas aplicadas en esta evaluación, el análisis a continuación se realiza individualmente para cada pregunta',
    },
    OccupancyMap: {
        noEvents: 'No hay salas',
        classes: 'Sala(s)',
        vacancys: 'Vacantes totales',
        enrollment: 'Registros',
        occupancy: 'Ocupación',
        seeLesson: 'Ver aula',
        seeClass: 'Ver sala',
        teacher: 'Profesor',
    },
    AssessmentItemType: [
        {
            name: 'Realiza',
            value: 0,
        },
        {
            name: 'Valor',
            value: 1,
        },
        {
            name: 'Tiempo',
            value: 2,
        },
    ],
    AssessmentStatus: ['EN PROCESO', 'ACABADO', 'NO PUBLICADO', 'PUBLICADO'],
    ScoreStatus: [
        'No hace',
        'En desarrollo',
        'Regular',
        'Bueno',
        'Óptimo',
        'Excelente',
    ],
    AssessmentApplication: {
        comments: 'Ingrese comentarios para estudiantes',
        commentsButton: 'Cerrar comentarios',
        finish: 'Finalizar revisión',
    },
    Rightpanel: {
        info: 'Informacciones',
        addFile: 'Agregar archivo',
        editFile: 'Editar archivo',
        seeFile: 'Visualizar',
        download: 'Descargar',
        startDate: 'Início',
        endDate: 'Final',
        plans: 'Planos',
        profiles: 'Perfis',
        extension: 'Extensión',
        picture: 'Pon tu foto',
        dragFile: 'Arrastra un archivo aquí',
        selectFile: ['O si lo prefieres ...', 'Selecciona un archivo'],
        share: 'Compartilhar',
    },
    EmptyState: {
        notFound: 'No encontramos nada aquí',
        createNewAssessment: 'comenzando una evaluación en un estudiante',
        createNewRegistry: 'Pero puedes crear un nuevo registro',
        clickingHere: 'haciendo clic aquí',
    },
    Filter: {
        title: 'Filtro',
        label: 'Filtros activos',
        Status: 'Status',
        Plans: 'Planos',
        Profiles: 'Perfis',
        StartDate: 'Data inicial',
        StartTime: 'Hora inicial',
        EndDate: 'Data final',
        EndTime: 'Hora final',
        TeacherPublicIds: 'Profesor(es)',
        StudentPublicIds: 'Estudiantes',
        NumberOfStudents: 'Numero de estudiantes',
        MinNumberOfStudents: 'Min. Numero de estudiantes',
        MaxNumberOfStudents: 'Max. Numero de estudiantes',
        LevelPublicIds: 'Niveles',
        ClassTeachingAreaPublicIds: 'Piscinas',
        DayOfTheWeeks: 'Dia de la semana',
        HasResponsible: 'Estudiante con apoderado',
        HasEmail: 'Acceso a la plataforma',
        HasDependant: 'Apoderado con estudiante',
        Name: 'Nombre',
        Document: 'Documento',
        CompanyName: 'Nombre social',
        TradingName: 'Nome de fantasia',
        Registration: 'Número de contacto',
        Email: 'E-mail',
        Telephone: 'Numero de contrato',
        AssessmentStatus: [
            {
                name: 'En proceso',
                value: true,
            },
            {
                name: 'Acabado',
                value: false,
            },
            {
                name: 'Publicado',
                value: false,
            },
            {
                name: 'No publicado',
                value: false,
            },
        ],
    },
}
